(() => {
  if (customElements.get('bf-recently-viewed')) return;

  const STORAGE_KEY = 'bf_recently_viewed_products_v1';
  const HISTORY_LIMIT = 8;

  class BFRecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.initialize();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    readHistory() {
      try {
        const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        if (!Array.isArray(value)) return [];
        return value.filter((handle) => typeof handle === 'string' && handle.length > 0);
      } catch (error) {
        return [];
      }
    }

    writeHistory(handles) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, HISTORY_LIMIT)));
      } catch (error) {}
    }

    productUrl(handle) {
      const root = (this.dataset.root || '/').replace(/\/?$/, '/');
      const url = new URL(`${root}products/${encodeURIComponent(handle)}`, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);

      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

      return url;
    }

    preservePreviewLinks(card) {
      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (!previewThemeId) return;

      card.querySelectorAll('a[href]').forEach((anchor) => {
        try {
          const url = new URL(anchor.href, window.location.origin);
          if (url.origin !== window.location.origin) return;
          url.searchParams.set('preview_theme_id', previewThemeId);
          anchor.href = url.href;
        } catch (error) {}
      });
    }

    async fetchCard(handle) {
      try {
        const response = await fetch(this.productUrl(handle), {
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest',
          },
          signal: this.controller.signal,
        });

        if (!response.ok) return null;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector('template[data-bf-recent-card-source]');
        if (!source?.content?.firstElementChild) return null;

        const card = source.content.firstElementChild.cloneNode(true);
        this.preservePreviewLinks(card);
        return card;
      } catch (error) {
        if (error?.name !== 'AbortError') console.warn('Recently viewed card could not be loaded', error);
        return null;
      }
    }

    async initialize() {
      const currentHandle = this.dataset.currentHandle;
      if (!currentHandle) return;

      const history = this.readHistory();
      const previous = history.filter((handle) => handle !== currentHandle);
      const uniquePrevious = [...new Set(previous)];
      const limit = Math.max(1, Number.parseInt(this.dataset.limit || '4', 10) || 4);
      const handlesToShow = uniquePrevious.slice(0, limit);

      this.writeHistory([currentHandle, ...uniquePrevious]);

      if (this.dataset.enabled !== 'true' || handlesToShow.length === 0) {
        this.hidden = true;
        return;
      }

      const cards = (await Promise.all(handlesToShow.map((handle) => this.fetchCard(handle)))).filter(Boolean);
      if (!this.isConnected || this.controller.signal.aborted) return;

      const grid = this.querySelector('[data-bf-recent-grid]');
      if (!grid || cards.length === 0) {
        this.hidden = true;
        return;
      }

      grid.replaceChildren(...cards);
      this.hidden = false;
    }
  }

  customElements.define('bf-recently-viewed', BFRecentlyViewed);
})();
